import React, { useState } from "react";
import { generateCoordinates, generateMapImageURL } from "services/geoapify";
import * as Yup from "yup";
import Form from "components/UI/Form/Form";
import TextField from "components/UI/Form/TextField";
import { agregarDatos, editar } from "services/crudFirebase";
import { v4 as uuidv4 } from "uuid";
import "./FormAddOrEditBranchOffice.scss";
import Backdrop from "@material-ui/core/Backdrop";
import CircularProgress from "@material-ui/core/CircularProgress";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    backdrop: {
        zIndex: theme.zIndex.drawer + 1,
        color: "#fff",
    },
}));

const FormAddOrEditBranchOffice = ({
    type,
    setStateModal,
    item,
    items,
    setItems,
}) => {
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const handleClose = () => setOpen(false);

    const [valuesForm, setValuesForm] = useState(
        type === "add"
            ? {
                  tipoDeSucursal: "",
                  nombrePlaza: "",
                  infoLocal: "",
                  ciudad: "",
                  calle: "",
                  numeroExt: "",
                  numeroInt: "",
                  colonia: "",
                  codigoPostal: "",
                  estado: "",
                  telefono: "",
                  horario: "",
                  imgMapa: "",
                  lon: "",
                  lat: "",
                  id: "",
                  linkMaps: "",
              }
            : {
                  tipoDeSucursal: item.tipoDeSucursal,
                  nombrePlaza: item.nombrePlaza,
                  infoLocal: item.infoLocal,
                  ciudad: item.ciudad,
                  calle: item.calle,
                  numeroExt: item.numeroExt,
                  numeroInt: item.numeroInt,
                  colonia: item.colonia,
                  codigoPostal: item.codigoPostal,
                  estado: item.estado,
                  telefono: item.telefono,
                  horario: item.horario.replace(/<br\/>/g, "\n"),
                  imgMapa: item.imgMapa,
                  lon: item.lon,
                  lat: item.lat,
                  id: item.id,
                  linkMaps: item.linkMaps,
              }
    );

    const resetForm = () => {
        setValuesForm({
            tipoDeSucursal: "",
            nombrePlaza: "",
            infoLocal: "",
            ciudad: "",
            calle: "",
            numeroExt: "",
            numeroInt: "",
            colonia: "",
            codigoPostal: "",
            estado: "",
            telefono: "",
            horario: "",
            imgMapa: "",
            lon: "",
            lat: "",
            id: "",
            linkMaps: "",
        });
    };

    const getMapUrl = async (values) => {
        const coord = await generateCoordinates(
            values.numeroExt,
            values.calle,
            values.ciudad,
            values.codigoPostal
        );
        return generateMapImageURL(coord);
    };

    const handleSubmit = async (values) => {
        setOpen(true);
        setValuesForm(values);
        let urlImg = "";
        if (
            (values.lon === "" && values.lat === "") ||
            (values.lon === undefined && values.lat === undefined)
        ) {
            urlImg = await getMapUrl(values);
            values.lon = "";
            values.lat = "";
        } else {
            urlImg = generateMapImageURL([values.lon, values.lat]);
        }
        values.imgMapa = urlImg;
        values.horario = values.horario.replace(/\n/g, "<br/>");
        if (type === "add") {
            values.id = uuidv4();
            onAddBrandOffice(values);
        }
        if (type === "edit") {
            onEditBrandOffice(values);
        }
        setStateModal(false);
        resetForm();
    };

    const onAddBrandOffice = (values) => {
        const destructuredItems = [...items, values];
        setItems(destructuredItems);
        agregarDatos(values, "InfoSucursales");
    };

    const onEditBrandOffice = (values) => {
        editar(values, "InfoSucursales");
        const destructuredItems = [...items];
        const newItems = destructuredItems.map((i) => {
            if (i.id === values.id) {
                return values;
            } else {
                return i;
            }
        });
        setItems(newItems);
    };

    const validate = Yup.object({
        nombrePlaza: Yup.string(),
        infoLocal: Yup.string(),
        tipoDeSucursal: Yup.string(),
        ciudad: Yup.string().required("El campo es obligatorio"),
        calle: Yup.string().required("El campo es obligatorio"),
        numeroExt: Yup.string(),
        numeroInt: Yup.string(),
        colonia: Yup.string().required("El campo es obligatorio"),
        codigoPostal: Yup.number()
            .typeError("Ingrese un código postal válido")
            .lessThan(100000, "Ingrese un código postal válido")
            .moreThan(999, "Ingrese un código postal válido")
            .required("El campo es obligatorio")
            .integer("Ingrese un código postal válido")
            .required("El campo es obligatorio"),
        estado: Yup.string().required("El campo es obligatorio"),
        telefono: Yup.number()
            .typeError("Ingrese un número telefónico válido")
            .lessThan(10000000000, "El número debe ser de 10 dígitos")
            .moreThan(999999999, "El número debe ser de 10 dígitos")
            .required("El campo es obligatorio")
            .integer("Ingrese un número telefónico válido"),
        horario: Yup.string().required("El campo es obligatorio"),
        lon: Yup.string(),
        lat: Yup.string(),
        linkMaps: Yup.string().required("El campo es obligatorio"),
    });

    return (
        <div className="formBranchOffices">
            <Form
                validate={validate}
                valuesForm={valuesForm}
                handleSubmit={handleSubmit}
                type={type}
            >
                <>
                    <TextField
                        label="Nombre de plaza comercial"
                        name="nombrePlaza"
                        type="text"
                        infoText={
                            <>
                                Añade <b>nombre de plaza comercial</b> en caso
                                de que la sucucursal esté localizada en algún
                                centro o plaza comercial
                                <br />
                                En su defecto dejar en blanco
                            </>
                        }
                    />
                    <TextField
                        label={<>Tipo de sucursal</>}
                        name="tipoDeSucursal"
                        type="text"
                        infoText={
                            <>
                                Añade <b>tipo de sucursal</b> <br />
                                <ul>
                                    <li>Local</li>
                                    <li>Matriz</li>
                                </ul>
                                <br />
                                En su defecto dejar en blanco
                            </>
                        }
                    />
                    <TextField
                        label="Info del local"
                        name="infoLocal"
                        type="text"
                        infoText={
                            <>
                                Añade el <b>número, nivel y las referencias</b>{" "}
                                necesarias en caso de que la sucursal sea un
                                Local
                                <br />
                                En su defecto dejar en blanco
                            </>
                        }
                    />
                    <TextField
                        label={
                            <>
                                Ciudad <span className="required">*</span>
                            </>
                        }
                        name="ciudad"
                        type="text"
                        infoText={
                            <>
                                Añade el <b>municipio o ciudad</b> donde esta
                                ubicada la sucursal
                            </>
                        }
                    />
                    <TextField
                        label={
                            <>
                                Calle <span className="required">*</span>
                            </>
                        }
                        name="calle"
                        type="text"
                        infoText={
                            <>
                                Añade la <b>avenida o calle</b> donde esta
                                ubicada la sucursal
                            </>
                        }
                    />
                    <TextField
                        label={<>Número exterior</>}
                        name="numeroExt"
                        type="text"
                        infoText={
                            <>
                                Añade el <b>número exterior</b> del lugar donde
                                esta ubicada la sucursal
                                <br />
                                En su defecto dejar en blanco
                            </>
                        }
                    />
                    <TextField
                        label={<>Número interior</>}
                        name="numeroInt"
                        type="text"
                        infoText={
                            <>
                                Añade el <b>número interior</b> del lugar donde
                                esta ubicada la sucursal
                                <br />
                                En su defecto dejar en blanco
                            </>
                        }
                    />
                    <TextField
                        label={
                            <>
                                Colonia <span className="required">*</span>
                            </>
                        }
                        name="colonia"
                        type="text"
                        infoText={
                            <>
                                Añade la <b>colonia</b> en que esta ubicada la
                                sucursal
                            </>
                        }
                    />
                    <TextField
                        label={
                            <>
                                Código postal{" "}
                                <span className="required">*</span>
                            </>
                        }
                        name="codigoPostal"
                        type="text"
                        infoText={
                            <>
                                Añade el <b>código postal</b> que pertenezca a
                                la ubicación de la sucursal
                            </>
                        }
                    />
                    <TextField
                        label={
                            <>
                                Estado <span className="required">*</span>
                            </>
                        }
                        name="estado"
                        type="text"
                        infoText={
                            <>
                                Añade el <b>estado</b> en que esta ubicada la
                                sucursal
                            </>
                        }
                    />
                    <TextField
                        label={
                            <>
                                Teléfono <span className="required">*</span>
                            </>
                        }
                        name="telefono"
                        type="text"
                        infoText={
                            <>
                                Añade el <b>número telefónico</b> de la
                                sucursal. En caso de que la sucursal no cuente
                                con un número propio solicitar a los
                                administradores adquirir uno y configurarlo con
                                WhatsApp Business
                            </>
                        }
                    />
                    <TextField
                        label={<>Longitud</>}
                        name="lon"
                        type="text"
                        infoText={
                            <>
                                Añade la <b>Longitud</b> en caso de que la
                                ubicación mapa no se carge correctamente o de
                                que hayas adquirido las coordenadas exactas de
                                la sucursal
                                <br />
                                En su defecto dejar en blanco
                            </>
                        }
                    />
                    <TextField
                        label={<>Latitud</>}
                        name="lat"
                        type="text"
                        infoText={
                            <>
                                Añade la <b>Latitud</b> en caso de que la
                                ubicación mapa no se carge correctamente o de
                                que hayas adquirido las coordenadas exactas de
                                la sucursal
                                <br />
                                En su defecto dejar en blanco
                            </>
                        }
                    />
                    <TextField
                        label={
                            <>
                                Vínculo Google Maps <span className="required">*</span>
                            </>
                        }
                        name="linkMaps"
                        type="text"
                        infoText={
                            <>
                                Añade el <b>vínculo de Google Maps</b>. Para
                                ello introduce la ubicación de la sucursal en
                                Google Maps, selecciona comparir y copia el
                                vínculo
                            </>
                        }
                    />
                    <TextField
                        label={
                            <>
                                Horario <span className="required">*</span>
                            </>
                        }
                        name="horario"
                        type="text"
                        infoText={
                            <>
                                Añade el <b>horario</b> del local como figura en
                                la tarjeta de contacto de la sucursal
                            </>
                        }
                        autosize
                    />
                </>
            </Form>
            <Backdrop
                className={classes.backdrop}
                open={open}
                onClick={handleClose}
            >
                <CircularProgress color="inherit" />
            </Backdrop>
        </div>
    );
};

export default FormAddOrEditBranchOffice;
